import { useState, useEffect, useContext } from 'react';
import { Typography, Box, IconButton, Stack, Button } from '@mui/material';
import { useParams } from 'react-router';
import TopBar from '../../components/topbar';
import { getTurfDetails } from '../../services/turf';
import AddBooking from '../../components/newBooking'
import LoginWarning from '../../components/loginWarning'
import userContext from '../../context/userContext';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { useNavigate } from "react-router-dom";

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MoreTimeIcon from '@mui/icons-material/MoreTime';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isTomorrow from 'dayjs/plugin/isTomorrow'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isToday from 'dayjs/plugin/isToday';

dayjs.extend(isSameOrBefore)
dayjs.extend(isToday);
dayjs.extend(isTomorrow);
dayjs.extend(customParseFormat);

const checkBookingForHour = (hour, bookings, day) => {
    let firstHalfBooked = false;
    let secondHalfBooked = false;

    bookings.forEach((booking) => {
        if (dayjs(day, 'DD/MM/YYYY').isSame(dayjs(booking.from), 'day') || dayjs(day).isSame(dayjs(booking.to), 'day') ) {
            const [startHour, startMin] = dayjs(booking.from).format('HH:mm').split(":").map(Number);
            const [endHour, endMin] = dayjs(booking.to).format('HH:mm').split(":").map(Number);
            console.log(startHour, startMin, endHour, endMin)
            if (
                (startHour === hour &&  startMin <= 29) || // Starts in first half
                (endHour === hour && endMin === 29) || // Ends exactly at 29 mins
                (startHour < hour && endHour >= hour) // Booking spans this hour
              ) {
                firstHalfBooked = true;
              }
        
              // Second Half: (30 - 59 mins)
              if (
                (startHour === hour &&  startMin <= 59) || // Starts in second half
                (endHour === hour && endMin === 59) || // Ends exactly at 59 mins
                (startHour < hour && endHour > hour) // Booking spans this hour
              ) {
                secondHalfBooked = true;
              }
            }
        });
        return { firstHalfBooked, secondHalfBooked };
  };

const Caraousel = () =>{
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
            <Carousel>
                <div style={{width: '100%' }}>
                    <img width="200" style={{width: '100%'}} src="https://media.istockphoto.com/id/983979694/photo/corner-line-of-an-indoor-football-soccer-training-field.webp?s=2048x2048&w=is&k=20&c=7CGWN6PHwa7CajuxY2tOje6rW4ezphC8XrarjimaX3Q="/>
                </div>
                <div style={{width: '100%'}}>
                    <img width="200" style={{width: '100%'}} src="https://media.istockphoto.com/id/520999573/photo/indoor-soccer-football-field.webp?s=2048x2048&w=is&k=20&c=sEaLqrZcgrrBr_7w72uMozNAE-toq0u6UbVmXKvH1Fs="/>
                </div>
                <div style={{width: '100%'}}>
                    <img width="200" style={{width: '100%'}} src="https://media.istockphoto.com/id/520999573/photo/indoor-soccer-football-field.webp?s=2048x2048&w=is&k=20&c=sEaLqrZcgrrBr_7w72uMozNAE-toq0u6UbVmXKvH1Fs="/>
                </div>  
            </Carousel>
        </Box>
    )
}

const TitleBar = ({name}) => {
    const navigate = useNavigate();
    return(
        <Box sx={{mb:1, display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <IconButton onClick={()=>{navigate('/')}}><ArrowBackIcon/></IconButton>
            <Typography sx={{fontWeight:'bold', ml: 2, pt: .5}}>{name}</Typography>
        </Box>
    )
}

const SingleHour =({hour, bookings, day}) =>{
    const { firstHalfBooked, secondHalfBooked } = checkBookingForHour(hour, bookings, day);
    return(
        <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <Box sx={{height: '25px', width: '25px', mr: '5px', background: `linear-gradient(to right, ${firstHalfBooked ? "red" : "green"} 50%, ${secondHalfBooked ? "red" : "green"} 50%)`}}></Box>
            <Typography>{hour}</Typography>
        </Box>
    )
}
const DayRow = ({bookings, day}) =>{
    const hours = Array.from({ length: 24 }, (_, i) => i);
    const morningHours = hours.slice(0, 12); // 00:00 to 11:00
    const eveningHours = hours.slice(12, 24); // 12:00 to 23:00
  
    return (
        <Stack direction="column">
            <Stack sx={{mb:1}} direction="row">
                {morningHours.map(hour => (<SingleHour hour={hour} bookings={bookings} day={day}/>))}
            </Stack>
            <Stack direction="row">
                {eveningHours.map(hour => (<SingleHour hour={hour} bookings={bookings} day={day}/>))}
            </Stack>
            
        </Stack>
    )
}

const DaySection = ({bookings, day}) => {
    
    let title = day;
    if (dayjs(day, 'DD/MM/YYYY').isToday()) {
        title = 'Today'
    }

    if (dayjs(day, 'DD/MM/YYYY').isTomorrow()) {
        title = 'Tomorrow'
    }
    
    return (
        <Box sx={{mb: 4}}>
            <Box sx={{ mb:1,pb: 1 }}>
                <Typography>{title}</Typography>
                <DayRow bookings={bookings} day={day}/>
            </Box>
        </Box>
    )
}

const AvailabilitySection = ({bookings, from, to}) => {
    const days = []
    for (var m = dayjs(from); m.isSameOrBefore(to); m = m.add(1, 'day')) {
        days.push(<DaySection bookings={bookings} day={m.format('DD/MM/YYYY')}/>);
    }
    return (
        <Box sx={{pl:2, pr: 2}}>
            {days}
        </Box>
    )
}

const Detail = () => {
    const params= useParams()
    const [turfDetails, setTurfDetails] = useState()
    const [bookingDetails, setBookingDetails] = useState([])
    const [openAddBooking, setOpenAddBooking] = useState(false)
    const [shouldRefresh, setShouldRefresh] = useState(false)
    const [showLoginWarning, setShowLoginWarning] = useState(false)
    const { user } = useContext(userContext);
    const from = dayjs().format('YYYY-MM-DD')
    const to = dayjs().add(1, 'day').format('YYYY-MM-DD')
    
    const _getTurfDetails = async (id) => {
        const data = await getTurfDetails(id, from, to)
        setTurfDetails(data?.turf)
        setBookingDetails(data?.bookings ?? [])
    }

    const handleAddButtonClick = () => {
        if (user) {
            setOpenAddBooking(true)
        } else {
            setShowLoginWarning(true)
        }
    }

    useEffect(() => {
        if (params.id) {
            _getTurfDetails(params.id);
        }
    }, [params.id])

    useEffect(()=>{
        if (shouldRefresh) {
            setShouldRefresh(false);
            _getTurfDetails(params.id);
        }
    }, [shouldRefresh])

    return (
        <>
            <TitleBar name={turfDetails?.name}/>
            <Caraousel/>
            <Box sx={{pr:2, mb:2, display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'flex-end'}}>
                <Button
                    variant="contained"
                    startIcon={<MoreTimeIcon/>}
                    onClick={handleAddButtonClick}
                >
                    Book
                </Button>
            </Box>
            <AvailabilitySection from={from} to={to} bookings={bookingDetails} />
            {openAddBooking && <AddBooking
                        open={openAddBooking}
                        setOpen={setOpenAddBooking}
                        setShouldRefresh={setShouldRefresh}
                        rate={turfDetails.rate}
                        turfId={turfDetails._id}
                    />}
            {showLoginWarning && <LoginWarning open={showLoginWarning} setOpen={setShowLoginWarning}/>}
        </>
    )

}

export default Detail;